import LoadMore from './LoadMore';

export default LoadMore;
export * from './LoadMore';
